<template>
 <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Ir para Orçamento de exames</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <div class="alert alert-warning" role="alert">
              <strong>Você quer realizar a busca de apenas um exame ou deseja realizar um orçamento de mais de um exame?</strong>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col text-right mb-2">
            <div class="btn-login">
              <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Apenas 1 exame</button>
              <button type="button" @click="irParaOrcamento()" class="btn btn-primary">Realizar Orçamento</button>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    irParaOrcamento () {
      this.$nextTick(() => window.$('#drAcheiModal').modal('toggle'))
      this.$router.push({name: 'Orcamento'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ModalIrParaOrcamento.vue